import React from 'react'
import cx from 'classnames'
import UpdatePageTitle from '../../utils/common'
import './styles.css'

const About = () => {
  UpdatePageTitle('About')
  return (
    <section className={cx('section')}>
      <h1 className={cx('section-header')}>About</h1>
      <div className={cx('article-content')}>
        <p>As you may have guessed from the site’s title or subtitle, I’m a software dev(I think my name’s hidden somewhere on this page) who in his free time dabbles with another kind of keyboard. Pardon the pun. I was introduced to both piano and computer at a young age and eventually fell for them though not necessarily in the Head Over Heels fashion. So one ended up being my career while the other still continues being my sanity preserving hobby.</p>
        <p>I enjoy working on the full-stack webscape and am oblivious to <a rel='noopener noreferrer' target='_blank' href='http://www.codinghorror.com/blog/2007/07/the-principle-of-least-power.html'>Atwood’s Law</a>. When I’m not too busy experimenting with either JavaScript, Python or Go(Lang) on the computer, I’ll be playing Rachmaninoff, Progressive Rock or Clayderman on the piano. Chopin and Lizst are just a little harder but I’ll get there eventually. This site has been built with the wonderful <a href='https://github.com/facebookincubator/create-react-app' rel='noopener noreferrer' target='_blank'>Create React App</a> and all it&#39;s numerous underlying technolgies nicely abstracted away from me.</p>
        <p>If you’ve reached this section while reading everything above, I think you’ll agree that you’ve more time than you realize. I appreciate that. If you’d like, you can keep up with me on these colorful social channels below.</p>
      </div>
      {/* Social Media Buttons */}
      <ul className={cx('social-widget-list')}>
        <li><a href='https://twitter.com/knick_hill'><i className={cx('fa', 'fa-twitter')} /></a></li>
        <li><a href='https://linkedin.com/in/mohannikhil/'><i className={cx('fa', 'fa-linkedin')} /></a></li>
        <li><a href='https://github.com/pianeer'><i className={cx('fa', 'fa-github')} /></a></li>
      </ul>
    </section>
  )
}

export default About



// WEBPACK FOOTER //
// ./src/client/containers/about/index.js